import { combineReducers } from 'redux';

import { reducer as authorize } from './authorizeModule';
import { reducer as logout } from './logoutModule';

export default combineReducers({
	authorize,
	logout,
});
